import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  TimePicker,
  Row,
  Col,
  Space,
  Card,
  Layout,
  Tag,
  Table,
  message,
  Menu,
  Dropdown,
  Spin,
  Pagination,
  Avatar,
} from "antd";
import {
  ContainerOutlined,
  MenuOutlined,
  UserOutlined,
} from "@ant-design/icons";
import SideBar from "./_sideBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import dayjs from "dayjs";
import CopyRight from "./CopyRight";

const { RangePicker } = DatePicker;

const EnquiryForm = () => {
  const [enquriy, setEnquriy] = useState({
    merchantName: "",
    invoiceNo: null,
    orderDateFrom: "",
    orderTimeFrom: "",
    orderDateTo: "",
    orderTimeTo: "",
  });

  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchValues, setSearchValues] = useState({});
  const [menuDisabled, setMenuDisabled] = useState(false);
  const [nextMenuDisabled, setNextMenuDisabled] = useState(false);
  const [transactionList, setTransactionList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [merchant, setMerchant] = useState();
  const [subMerchant, setSubMerchant] = useState();
  const [selectedMerchantCodes, setSelectedMerchantCodes] = useState([]);
  const [loginUser, setLoginUser] = useState();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [form] = Form.useForm();

  const loginUserToken = JSON.parse(localStorage.getItem("loginUserToken"));
  const user = JSON.parse(localStorage.getItem("loginUser"));
  const pageSize = 10;

  useEffect(() => {
    setLoginUser(user);
    getMerchantData();

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [form]);

  const getMerchantData = async () => {
    if (user.userRole === "ADMIN") {
      // ADMIN: fetch all merchants and subMerchants, no auto-selection
      const res = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/merchant/findAllMerchantAndSubMerchant`,
        {
          headers: {
            Authorization: `Bearer ${loginUserToken}`,
          },
        },
      );
      const data = res.data;

      console.log("M and SM", data);

      // Map the data to include subMerchants within each merchant object
      const merchantsWithSubMerchants = data.map((item) => ({
        ...item.merchant,
        subMerchants: item.subMerchants || [],
      }));

      setMerchant(merchantsWithSubMerchants);
      setSubMerchant(data.flatMap((m) => m.subMerchants)); // Flattening all subMerchants
    } else {
      // MERCHANT or SUBMERCHANT: fetch only their merchant and subMerchant data
      const res = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/merchant/findMerchantAndSubMerchant/${user.merchantCode}`,
        {
          headers: {
            Authorization: `Bearer ${loginUserToken}`,
          },
        },
      );
      const data = res.data;

      // Auto-fill merchant name for both MERCHANT and SUBMERCHANT
      form.setFieldsValue({
        merchantCode: data.merchant.merchantCode,
        merchantName: data.merchant.name,
      });

      // If user is SUBMERCHANT, also auto-fill submerchant
      if (user.subMerchantCode) {
        const subMerchantData = data.subMerchants.find(
          (s) => s.merchantCode === user.subMerchantCode,
        );
        form.setFieldsValue({
          subMerchantCode: subMerchantData?.merchantCode,
          subMerchantName: subMerchantData?.name,
        });
      }

      // For MERCHANT role, set merchant with subMerchants for filtering
      setMerchant([{ ...data.merchant, subMerchants: data.subMerchants }]);
      setSubMerchant(data.subMerchants);
      
      // For MERCHANT role, auto-select the merchant code for filtering
      if (!user.subMerchantCode) {
        setSelectedMerchantCodes([data.merchant.merchantCode]);
      }
    }
  };

  const navigate = useNavigate();

  const { Content } = Layout;

  const handleSearch = async (
    values,
    page = 0,
    size = pageSize,
    resetPagination = false,
  ) => {
    try {
      if (resetPagination) {
        setCurrentPage(0); // Reset pagination to the first page
      }
      setLoading(true);
      setDisabled(true);
      setTransactionList([]);

      const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const seconds = String(d.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      };

      const formatTime = (time) => {
        if (!time) return null;
        if (typeof time === "string") {
          return time; // Assume it's already in "HH:mm:ss" format
        }
        const t = new Date(time);
        if (isNaN(t.getTime())) {
          console.warn("Invalid time input:", time);
          return null; // Handle invalid date inputs
        }
        const hours = String(t.getHours()).padStart(2, "0");
        const minutes = String(t.getMinutes()).padStart(2, "0");
        const seconds = String(t.getSeconds()).padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
      };

      const formattedValues = {
        ...values,
        merchantCode: Array.isArray(values.merchantCode)
          ? values.merchantCode
          : values.merchantCode
            ? [values.merchantCode]
            : null,
        subMerchantCode: Array.isArray(values.subMerchantCode)
          ? values.subMerchantCode
          : values.subMerchantCode
            ? [values.subMerchantCode]
            : null,
        orderDateFrom: values.orderDateFrom
          ? formatDate(values.orderDateFrom)
          : null,
        orderDateTo: values.orderDateTo ? formatDate(values.orderDateTo) : null,
        // orderDateFrom: values.orderDateFrom
        //   ? formatDate(values.orderDateFrom, values.orderTimeFrom || "00:00:00")
        //   : null,

        // orderDateTo: values.orderDateTo
        //   ? formatDate(values.orderDateTo, values.orderTimeTo || "23:59:59")
        //   : null,
        orderTimeFrom: values.orderTimeFrom
          ? formatTime(values.orderTimeFrom)
          : null,
        orderTimeTo: values.orderTimeTo ? formatTime(values.orderTimeTo) : null,
        // orderTimeFrom: values.orderTimeFrom
        //   ? values.orderTimeFrom.format("HH:mm:ss")
        //   : null,
        // orderTimeTo: values.orderTimeTo
        //   ? values.orderTimeTo.format("HH:mm:ss")
        //   : null,
        invoiceNo: values.invoiceNo?.trim() || null,
        status:
          Array.isArray(values.status) && values.status.length > 0
            ? values.status
            : null,
        paymentChannel:
          Array.isArray(values.paymentChannel) &&
          values.paymentChannel.length > 0
            ? values.paymentChannel
            : null,
      };

      setSearchValues(formattedValues);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/enquiry/search?page=${page}&size=${size}`,
        formattedValues,
        {
          headers: {
            Authorization: `Bearer ${loginUserToken}`,
          },
        },
      );

      const { content, totalElements, totalPages } = response.data;
      console.log("CONTENT", content);

      setTransactionList(content);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      message.error("Failed to fetch transactions. Please try again.");
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  const handleDownload = () => {
    // Define the headers for the Excel file
    const headers = [
      "No.",
      "Invoice No/Order ID",
      "Merchant Name",
      "SubMerchant Name",
      "Bank Reference No.",
      "Payment Channel",
      "Product Description",
      "Status",
      "Transaction Date/Time",
      "Transaction Amount",
      "Service Charges",
      "Total Amount",
    ];

    // Generate rows for the Excel file
    const rows = transactionList.map((row, index) => {
      const transactionDateTime = moment(row.date).format(
        "DD/MM/YYYY HH:mm:ss",
      );
      const paymentChannel = row.paymentChannel;
      const productDescription = row.productDescription;
      const bankReferenceNo = row.bankReferenceNo;
      const transactionStatus =
        row.transactionStatus === "SUCCESS" ? "Success" : "Pending";
      const transactionAmount = row.transactionAmount;
      const serviceCharges = row.serviceFee;
      const totalAmount = row.transactionAmount + row.serviceCharges;

      // Return the row as an array of values
      return [
        index + 1,
        row.invoiceNo || "",
        row.merchantName || "",
        row.subMerchantName || "",
        bankReferenceNo || "",
        paymentChannel || "",
        productDescription || "",
        transactionStatus,
        transactionDateTime,
        transactionAmount,
        serviceCharges,
        totalAmount,
      ];
    });

    // Add headers to the rows
    const data = [headers, ...rows];

    // Create a worksheet from the data
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

    // Write the Excel file and trigger the download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${loginUser.name || "default"}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePrint = () => {
    const printContent = document.createElement("div");
    const tableHtml = document.querySelector(".ant-table").outerHTML;
    printContent.innerHTML = tableHtml;

    const printWindow = window.open("", "_blank");
    printWindow.document.write("<html><head><title>Print</title></head><body>");
    printWindow.document.write(printContent.innerHTML);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  const handleClear = () => {
    form.resetFields();
    getMerchantData();
    setTransactionList([]);
  };

  const columns = [
    {
      title: "No.",
      key: "index",
      dataIndex: "index",
      render: (_, __, index) => currentPage * pageSize + index + 1, // Adjust for pagination
    },
    {
      title: "Date/Time",
      dataIndex: "date",
      key: "date",
      render: (text) => moment(text).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: "Merchant Name",
      dataIndex: "merchantName",
      key: "merchantName",
    },
    {
      title: "SubMerchant Name",
      dataIndex: "subMerchantName",
      key: "subMerchantName",
    },
    {
      title: "Invoice No/Order ID",
      dataIndex: "invoiceNo",
      key: "invoiceNo",
    },
    {
      title: "Bank Reference No.",
      dataIndex: "bankReferenceNo",
      key: "bankReferenceNo",
    },
    {
      title: "Payment Channel",
      dataIndex: "paymentChannel",
      key: "paymentChannel",
    },
    {
      title: "Inter Bank",
      dataIndex: "walletIdentifier",
      key: "walletIdentifier",
    },
    {
      title: "Product Description",
      dataIndex: "productDescription",
      key: "productDescription",
    },
    {
      title: "Transaction Amount",
      dataIndex: "transactionAmount",
      key: "transactionAmount",
      align: "right",
      render: (text) => {
        return new Intl.NumberFormat("en-MM", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(text);
      },
    },
    {
      title: "Service Fee",
      dataIndex: "serviceCharges",
      key: "serviceCharges",
      align: "right",
      render: (text) => {
        return new Intl.NumberFormat("en-MM", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(text);
      },
    },
    {
      title: "Total Amount",
      key: "totalAmount",
      align: "right",
      render: (_, record) => {
        const totalAmount = record.transactionAmount + record.serviceCharges;
        return new Intl.NumberFormat("en-MM", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(totalAmount);
      },
    },
    {
      title: "Currency",
      dataIndex: "currencyCode",
      key: "currency",
    },
    {
      title: "Status",
      dataIndex: "transactionStatus",
      key: "transactionStatus",
      render: (transactionStatus) => (
        <Tag color={transactionStatus === "SUCCESS" ? "blue" : "red"}>
          {transactionStatus}
        </Tag>
      ),
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
      render: (details) => <a href="#">{details}</a>,
    },
  ];

  const handleExport = async (fileType, criteriaValues) => {
    try {
      setLoading(true);
      setDisabled(true);

      const enquiryCriteriaDTO = {
        ...criteriaValues,
        merchantCode: Array.isArray(criteriaValues.merchantCode)
          ? criteriaValues.merchantCode.length > 0
            ? criteriaValues.merchantCode
            : null
          : criteriaValues.merchantCode
            ? [criteriaValues.merchantCode]
            : null,
        subMerchantCode: Array.isArray(criteriaValues.subMerchantCode)
          ? criteriaValues.subMerchantCode.length > 0
            ? criteriaValues.subMerchantCode
            : null
          : criteriaValues.subMerchantCode
            ? [criteriaValues.subMerchantCode]
            : null,
        orderDateFrom: criteriaValues.orderDateFrom
          ? criteriaValues.orderDateFrom.format("YYYY-MM-DD[T]HH:mm:ss")
          : null,
        orderDateTo: criteriaValues.orderDateTo
          ? criteriaValues.orderDateTo.format("YYYY-MM-DD[T]HH:mm:ss")
          : null,
        orderTimeFrom: criteriaValues.orderTimeFrom
          ? criteriaValues.orderTimeFrom.format("HH:mm:ss")
          : null,
        orderTimeTo: criteriaValues.orderTimeTo
          ? criteriaValues.orderTimeTo.format("HH:mm:ss")
          : null,
        invoiceNo:
          criteriaValues.invoiceNo === "" ? null : criteriaValues.invoiceNo,
        status: Array.isArray(criteriaValues.status)
          ? criteriaValues.status.length > 0
            ? criteriaValues.status
            : null
          : criteriaValues.status
            ? [criteriaValues.status]
            : null,
        paymentChannel: Array.isArray(criteriaValues.paymentChannel)
          ? criteriaValues.paymentChannel.length > 0
            ? criteriaValues.paymentChannel
            : null
          : criteriaValues.paymentChannel
            ? [criteriaValues.paymentChannel]
            : null,
      };

      // API request to export
      const url = `${process.env.REACT_APP_API_BACKEND_URL}/v1/enquiry/${fileType}`;
      const response = await axios.post(url, enquiryCriteriaDTO, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${loginUserToken}`,
        },
      });

      // Handle file download
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      // link.setAttribute(
      //   "download",
      //   `export.${fileType === "csv" ? "csv" : "xlsx"}`
      // );
      // Get current time in Myanmar Time (MMT)
      const myanmarTime = new Date().toLocaleString("en-GB", {
        timeZone: "Asia/Yangon", // Myanmar Time Zone (UTC+6:30)
        hour12: false, // Use 24-hour format
      });

      // Format filename with Myanmar Time
      link.setAttribute(
        "download",
        `${loginUser.name || "default"}_${new Date()
          .toLocaleString("en-GB", {
            timeZone: "Asia/Yangon",
            hour12: false,
          })
          .replace(",", "")
          .replace(/\//g, "-")
          .replace(/ /g, "_")
          .replace(/:/g, ":")}.${fileType === "csv" ? "csv" : "xlsx"}`,
      );

      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error exporting file:", error);
    } finally {
      setLoading(false); // Stop loading
      setDisabled(false); // Re-enable UI elements
    }
  };

  console.log("merchant =>", merchant);
  console.log("selectedMerchantCodes =>", selectedMerchantCodes);

  const filteredSubMerchants = React.useMemo(() => {
    if (!merchant || !Array.isArray(merchant)) return [];
    if (!selectedMerchantCodes.length) return [];

    const filtered = merchant
      .filter((m) => selectedMerchantCodes.includes(m.merchantCode))
      .flatMap((m) => m.subMerchants || []);

    console.log("filteredSubMerchants =>", filtered);
    return filtered;
  }, [merchant, selectedMerchantCodes]);

  console.log("filtered =>", filteredSubMerchants);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SideBar
        menuDisabled={menuDisabled}
        nextMenuDisabled={nextMenuDisabled}
        fontSize="14px"
        drawerVisibleValue={drawerVisible}
        setDrawerVisibleValue={setDrawerVisible}
      />
      <Layout className="site-layout">
        <Content>
          <div className="site-layout-background" style={{ minHeight: 360 }}>
            <Space
              direction="vertical"
              style={{ padding: "10px", width: "100%" }}
            >
              <Card
                title={
                  <span>
                    {isMobile && (
                      <MenuOutlined
                        onClick={() => setDrawerVisible((prev) => !prev)}
                        style={{ marginRight: 8, fontSize: 30 }}
                      />
                    )}
                    <ContainerOutlined style={{ marginRight: 8 }} />
                    Enquiry
                  </span>
                }
                headStyle={{ backgroundColor: "#cccccc" }}
                extra={
                  <span>
                    {loginUser?.username}
                    <Avatar
                      src={loginUser?.avatarUrl}
                      icon={!loginUser?.avatarUrl && <UserOutlined />}
                      style={{ marginLeft: 8 }}
                    />
                  </span>
                }
              >
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column", // Stack items vertically
                      justifyContent: "center",
                      alignItems: "center", // Center the spinner and text horizontally
                      padding: "20px",
                    }}
                  >
                    <Spin size="large" />
                    <div style={{ marginTop: "10px" }}>
                      Please wait, searching transactions{" "}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <Form
                  disabled={disabled}
                  layout="vertical"
                  onFinish={(values) => {
                    setCurrentPage(0); // Reset pagination to the first page
                    handleSearch(values, 0, pageSize, true); // Call search handler with reset pagination
                  }}
                  form={form}
                  style={{
                    maxWidth: "1000px",
                    margin: "0 auto",
                  }}
                >
                  <Row gutter={16}>
                    {/* Merchant Name */}
                    <Col xs={24} sm={12}>
                      <Form.Item name="merchantCode" hidden>
                        <Input type="hidden" />
                      </Form.Item>

                      {loginUser?.userRole === "ADMIN" ? (
                        // ADMIN: Show dropdown to select merchants
                        <Form.Item label="Merchant" name="merchantCode">
                          <Select
                            mode="multiple"
                            placeholder="Select Merchant"
                            allowClear
                            onChange={(values) => {
                              console.log("selected merchants:", values);
                              setSelectedMerchantCodes(values);

                              form.setFieldsValue({
                                subMerchantCode: [],
                              });
                            }}
                          >
                            {merchant?.map((m) => (
                              <Select.Option
                                key={m.merchantCode}
                                value={m.merchantCode}
                              >
                                {m.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      ) : (
                        // MERCHANT or SUBMERCHANT: Show disabled input with merchant name
                        <Form.Item label="Merchant" name="merchantName">
                          <Input disabled />
                        </Form.Item>
                      )}
                    </Col>

                    {/* SubMerchant Name */}
                    <Form.Item name="subMerchantCode" hidden>
                      <Input type="hidden" />
                    </Form.Item>

                    {loginUser?.subMerchantCode ? (
                      // SUBMERCHANT: Show disabled input with submerchant name
                      <Col xs={24} sm={12}>
                        <Form.Item label="SubMerchant" name="subMerchantName">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    ) : (
                      // ADMIN or MERCHANT: Show dropdown to select submerchants
                      <Col xs={24} sm={12}>
                        <Form.Item label="SubMerchant" name="subMerchantCode">
                          <Select
                            mode="multiple"
                            placeholder="Select SubMerchant"
                            allowClear
                            disabled={
                              loginUser?.userRole === "ADMIN" &&
                              selectedMerchantCodes.length === 0
                            }
                          >
                            {filteredSubMerchants?.map((s) => (
                              <Select.Option
                                key={s.merchantCode}
                                value={s.merchantCode}
                              >
                                {s.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    )}

                    {/* Order Date From */}
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Order Date From"
                        name="orderDateFrom"
                        initialValue={dayjs().startOf("day")}
                      >
                        <DatePicker
                          style={{ width: "100%" }}
                          placeholder="Enter from date"
                          format={"YYYY-MM-DD"}
                        />
                      </Form.Item>
                    </Col>

                    {/* Order Date To */}
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Order Date To"
                        name="orderDateTo"
                        initialValue={dayjs().startOf("day")}
                      >
                        <DatePicker
                          style={{ width: "100%" }}
                          placeholder="Enter from date"
                          format={"YYYY-MM-DD"}
                        />
                      </Form.Item>
                    </Col>

                    {/* Order Time From */}
                    <Col xs={24} sm={12}>
                      <Form.Item label="Order Time From" name="orderTimeFrom">
                        <TimePicker
                          style={{ width: "100%" }}
                          placeholder="Enter from time"
                          format={"HH:mm:ss"}
                        />
                      </Form.Item>
                    </Col>

                    {/* Order Time To */}
                    <Col xs={24} sm={12}>
                      <Form.Item label="Order Time To" name="orderTimeTo">
                        <TimePicker
                          style={{ width: "100%" }}
                          placeholder="Enter to time"
                          format={"HH:mm:ss"}
                        />
                      </Form.Item>
                    </Col>

                    {/* Invoice Number/Order ID */}
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Invoice Number/Order ID"
                        name="invoiceNo"
                      >
                        <Input placeholder="Enter invoice number or order ID" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Form.Item label="Product Description" name="description">
                        <Input placeholder="Enter Product Description" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Form.Item name="status" hidden>
                        <Input type="hidden" />
                      </Form.Item>
                      <Form.Item label="Status" name="status">
                        <Select
                          mode="multiple"
                          placeholder="Select Transaction Status"
                          allowClear
                        >
                          <Select.Option value="SUCCESS">SUCCESS</Select.Option>
                          <Select.Option value="PENDING">PENDING</Select.Option>
                          <Select.Option value="IN_PROGRESS">
                            IN_PROGRESS
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    {/* Payment Channel */}
                    <Col xs={24} sm={12}>
                      <Form.Item label="Payment Channel" name="paymentChannel">
                        <Select
                          mode="multiple"
                          placeholder="Select Payment Channel"
                          allowClear
                        >
                          <Select.Option value="MMQR">
                            Myanmar Pay (MMQR)
                          </Select.Option>
                          <Select.Option value="KBZ_PAY">KBZ PAY</Select.Option>
                          <Select.Option value="AYA_PAY">AYA PAY</Select.Option>
                          <Select.Option value="CB_PAY">CB PAY</Select.Option>
                          <Select.Option value="OK_DOLLAR">
                            OK_DOLLAR
                          </Select.Option>
                          <Select.Option value="KBZ_USD">KBZ_USD</Select.Option>
                          <Select.Option value="KBZ_MPU">KBZ_MPU</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16} justify="start">
                    <Col>
                      <Button type="primary" htmlType="submit">
                        {loading ? "Searching..." : "Search"}
                      </Button>
                    </Col>

                    <Col>
                      <Button htmlType="button" onClick={handleClear}>
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>

              {loading ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column", // Stack items vertically
                    justifyContent: "center",
                    alignItems: "center", // Center the spinner and text horizontally
                    padding: "20px",
                  }}
                >
                  <Spin size="large" />
                  <div style={{ marginTop: "10px" }}>
                    Please wait, searching transactions{" "}
                  </div>
                </div>
              ) : (
                <>
                  {transactionList?.length > 0 && transactionList !== null ? (
                    <Row justify="end" style={{ marginTop: "20px" }}>
                      <Col>
                        <Dropdown
                          overlay={
                            <Menu>
                              <Menu.Item
                                key="csv"
                                onClick={() =>
                                  handleExport("csv", form.getFieldsValue())
                                }
                              >
                                Export CSV
                              </Menu.Item>
                              <Menu.Item
                                key="excel"
                                onClick={() =>
                                  handleExport("excel", form.getFieldsValue())
                                }
                              >
                                Export Excel
                              </Menu.Item>
                            </Menu>
                          }
                          placement="bottomLeft"
                        >
                          <Button
                            color="primary"
                            variant="outlined"
                            disabled={disabled}
                          >
                            {loading ? "Exporting..." : "Export"}{" "}
                            <DownOutlined />
                          </Button>
                        </Dropdown>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}

                  <Table
                    dataSource={transactionList}
                    columns={columns}
                    pagination={false}
                    bordered
                    scroll={{ x: "max-content" }}
                  />
                  <Pagination
                    current={currentPage + 1} // Ant Design uses 1-based indexing
                    pageSize={pageSize}
                    total={totalElements}
                    onChange={(page) => {
                      setCurrentPage(page - 1); // Adjust for zero-based indexing
                      handleSearch(searchValues, page - 1, pageSize); // Fetch data for selected page
                    }}
                    style={{ float: "right" }}
                  />
                </>
              )}
            </Space>
          </div>
          <CopyRight />
        </Content>
      </Layout>
    </Layout>
  );
};

export default EnquiryForm;
